import { render } from "./AppPractice.vue?vue&type=template&id=47acdb9c"
import script from "./AppPractice.vue?vue&type=script&lang=js"
export * from "./AppPractice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__